import React from "react";
import CrudManager from "@/components/admin/CrudManager";

export default function ProductsAdmin() {
  return (
    <CrudManager
      title="Products"
      description="Manage your product catalogue, specs and features."
      endpoint="products"
      fields={[
        { name: "name", label: "Product Name", type: "text" },
        { name: "slug", label: "URL Slug", type: "text", placeholder: "helmet-sanitization-station" },
        { name: "short_desc", label: "Short Description", type: "textarea", rows: 2 },
        { name: "description", label: "Full Description", type: "textarea", rows: 4 },
        { name: "image", label: "Product Image", type: "image" },
        { name: "features", label: "Key Features", type: "tags" },
        { name: "specs", label: "Specifications", type: "kv" },
        { name: "order", label: "Display Order", type: "number" },
        { name: "active", label: "Visible", type: "switch" },
      ]}
      columns={[
        { name: "image", label: "Image", type: "image" },
        { name: "name", label: "Name", type: "text" },
        { name: "slug", label: "Slug", type: "text" },
        { name: "active", label: "Status", type: "switch" },
      ]}
    />
  );
}
